module.exports = __webpack_public_path__ + "static/tasks-324cda9c6dfa6716ab215a7edcc22507.png";